import React from "react";
import CheckIcon from "../../icons/CheckIcon";
import Inbox from "../../icons/Inbox";

const ActionButton = ({ onClick, label, icon: IconComponent, className }) => (
    <div className="justify-self-end">
        <button onClick={onClick} className={`flex group items-center font-body font-normal text-xs rounded-full py-1 px-3 text-nowrap ${className}`}>
            {label}
            {IconComponent && <IconComponent />}
        </button>
    </div>
);

const MarkReadButton = ({ text, markRead }) => {
    const isRead = text.read && (!text.unread || new Date(text.read) > new Date(text.unread));

    if (isRead) {
        return (
            <ActionButton onClick={() => markRead(text)} label="Mark as unread" icon={() => <Inbox className="ml-1" />} className="hover:bg-black text-black hover:text-white border-2 border-black" />
        );
    } else {
        return <ActionButton onClick={() => markRead(text)} label="Mark as read" icon={CheckIcon} className="bg-black hover:bg-secondary text-white hover:text-white border-2 border-black w-32" />;
    }
};

export default MarkReadButton;
